import { IStaff } from "../model";

export const staffInitial: IStaff = {
  name: "",
  lastName:"",
  active:false,
  positionId:0,
  organizationId:0,
  id:0
};

